import React from "react";
import {
  Shield,
  Lock,
  Eye,
  AlertTriangle,
  Server,
  Key,
  FileSearch,
  Monitor,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Cybersecurity Solutions",
    description:
      "Build comprehensive security platforms for threat detection and response",
    icon: Shield,
  },
  {
    title: "Access Control Systems",
    description: "Develop identity management and authentication solutions",
    icon: Key,
  },
  {
    title: "Surveillance Platforms",
    description: "Create video analytics and monitoring systems",
    icon: Eye,
  },
  {
    title: "Threat Intelligence",
    description: "AI-powered threat detection and security analytics",
    icon: AlertTriangle,
  },
  {
    title: "Security Operations",
    description: "Build SOC dashboards and incident management systems",
    icon: Monitor,
  },
  {
    title: "Compliance Management",
    description: "Automate security compliance and audit reporting",
    icon: FileSearch,
  },
  {
    title: "Network Security",
    description: "Implement firewall management and intrusion detection",
    icon: Server,
  },
  {
    title: "Encryption Services",
    description: "Data encryption and secure communication solutions",
    icon: Lock,
  },
];

const STATS = [
  { value: "100+", label: "Security Projects" },
  { value: "Zero", label: "Breaches" },
  { value: "SOC2", label: "Certified" },
  { value: "24/7", label: "Monitoring" },
];

const SecurityIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="security"
      industryTitle="Security"
      industrySubtitle="Solutions"
      heroDescription="Protecting businesses with advanced cybersecurity solutions, surveillance systems, and access control platforms that safeguard assets and ensure compliance."
      themeColor="#475569"
      themeColorLight="#64748b"
      themeGradient="linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #475569 100%)"
      HeroIcon={Shield}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default SecurityIndustryPage;
